'use client'
import { usePathname } from 'next/navigation';
import { ShareIcon } from "lucide-react";

interface ShareButtonProps {
	size?: number;
};

const ShareButton = ({ size = 30 }: ShareButtonProps) => {
	const shareLink = `https://chenook.com${usePathname()}`;

	const onShareClick = async () => {
		try {
			await navigator.share({
				title: 'Let\'s collaborate on my Nook!',
				text: shareLink
			});
		} catch {
		}
	};

	return <button className='sm:hidden btn btn-square btn-ghost' onClick={onShareClick} aria-label="Open device share menu"
	><ShareIcon size={size} /></button>;
};

export default ShareButton;
